/* import __COLOCATED_TEMPLATE__ from './carousel.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import TEMPLATE from "./carousel.hbs";
import { setComponentTemplate } from "@ember/component";
export default setComponentTemplate(TEMPLATE, templateOnlyComponent());